/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Pipe, PipeTransform } from '@angular/core';
import { State } from '@core/store';
import { Store } from '@ngrx/store';
import { getLicenseClasses } from '@vehicles/store/vehicles.selectors';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'licenseClass',
    standalone: false
})
export class LicenseClassPipe implements PipeTransform {
  constructor(private store: Store<State>) { }

  transform(licenseClassId: number): Observable<string> {
    return this.store.select(getLicenseClasses).pipe(
      map(classes => classes.filter(licenseClass => licenseClass.id === licenseClassId)[0]),
      map(licenseClass => licenseClass ? licenseClass.name : '')
    );
  }
}
